/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useMemo, useCallback } from 'react';
import { shape, func, string, instanceOf, arrayOf, object, bool, } from 'prop-types';
import DayPicker, { DateUtils } from 'react-day-picker';
import { DateTime } from 'luxon';
import setClass from '../../common/set-class';
import Button from '../button';
import Dropdown from '../dropdown';
import NavBar from './nav-bar';
import Weekday from './weekday';
import Icon from '../icon';
const DateRangeSelect = (props) => {
    const { value, onChange, format, datesPreset, dayPickerProps, // http://react-day-picker.js.org/api/DayPicker
    isOpen, isDisabled, className, style, placeholder, } = props;
    const [from, setFrom] = useState(value?.from);
    const [to, setTo] = useState(value?.to);
    const modifiers = useMemo(() => ({ start: from, end: to }), [from, to]);
    const handleDayClick = useCallback((day) => {
        if (from && to) {
            setFrom(day);
            setTo(null);
            return;
        }
        const range = DateUtils.addDayToRange(day, { from, to });
        setFrom(range.from);
        setTo(range.to);
    }, [from, to]);
    const onDropdownOpen = useCallback(() => {
        setFrom(value?.from);
        setTo(value?.to);
    }, [value]);
    const strValue = useMemo(() => ({
        from: value?.from && DateTime.fromJSDate(value?.from).toFormat(format),
        to: value?.to && DateTime.fromJSDate(value?.to).toFormat(format),
    }), [value]);
    const getLabel = () => {
        for (let index = 0; index < datesPreset.length; index++) {
            const item = datesPreset[index];
            if (item.from === strValue.from && item.to === strValue.to) {
                return item.label;
            }
        }
        return `${DateTime.fromJSDate(value?.from).toFormat(format)} - ${DateTime.fromJSDate(value?.to).toFormat(format)}`;
    };
    return (React.createElement("div", { className: setClass('b-date-range', className), style: style },
        React.createElement(Dropdown, { onOpen: onDropdownOpen, isDisabled: isDisabled, name: "date-range-picker", isOpen: isOpen, render: (close) => (React.createElement(React.Fragment, null,
                datesPreset.map((item) => (React.createElement("div", { key: item.label, onClick: () => {
                        onChange({
                            from: item.from &&
                                DateTime.fromFormat(item.from, format).toJSDate(),
                            to: item.to &&
                                DateTime.fromFormat(item.to, format).toJSDate(),
                        });
                        close();
                    }, className: setClass('b-date-range__preset', value &&
                        item.from === strValue.from &&
                        item.to === strValue.to &&
                        'b-date-range__preset--active') }, item.label))),
                React.createElement("div", { className: "b-date-range__custom" },
                    React.createElement("div", null, " Custom "),
                    React.createElement(Button, { onClick: () => {
                            onChange({ from, to });
                            close();
                        }, disabled: !from || !to || (from === value?.from && to === value?.to), className: "b-date-range__submit", kind: "link" }, "Apply")),
                React.createElement(DayPicker, { selectedDays: [from, { from, to }], onDayClick: handleDayClick, locale: "en", modifiers: modifiers, navbarElement: NavBar, weekdayElement: Weekday, showOutsideDays: true, ...dayPickerProps }))) },
            React.createElement("div", { className: setClass('b-txt-input__elm b-date-range__trigger', !value && 'b-txt-light'), 
                // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: any[]; className: string; disabl... Remove this comment to see the full error message
                disabled: isDisabled },
                value ? getLabel() : placeholder,
                React.createElement(Icon, { name: "calendar", size: 18 })))));
};
DateRangeSelect.propTypes = {
    value: shape({
        from: instanceOf(Date),
        to: instanceOf(Date),
    }),
    onChange: func.isRequired,
    format: string,
    datesPreset: arrayOf(shape({
        label: string.isRequired,
        from: string,
        to: string,
    })),
    dayPickerProps: object,
    isOpen: bool,
    isDisabled: bool,
    className: string,
    style: object,
    placeholder: string,
};
const defaultFormat = 'MM/dd/yyyy';
DateRangeSelect.defaultProps = {
    format: defaultFormat,
    datesPreset: [],
    dayPickerProps: undefined,
    isOpen: undefined,
    isDisabled: undefined,
    className: undefined,
    style: undefined,
    placeholder: '',
};
DateRangeSelect.getDefaultDatesPreset = (format = defaultFormat) => [
    {
        label: 'Past 1 day',
        from: DateTime.now().minus({ days: 1 }).toFormat(format),
        to: DateTime.now().toFormat(format),
    },
    {
        label: 'Past 7 days',
        from: DateTime.now().minus({ days: 7 }).toFormat(format),
        to: DateTime.now().toFormat(format),
    },
    {
        label: 'Past 30 days',
        from: DateTime.now().minus({ days: 30 }).toFormat(format),
        to: DateTime.now().toFormat(format),
    },
    {
        label: 'All Time',
    },
];
export default DateRangeSelect;
